// extracted by mini-css-extract-plugin
module.exports = {"loading":"loader_loading__3piu6"};